// extracted by mini-css-extract-plugin
export var button = "_f3-4";
export var hasDarkBackground = "_f3-7";
export var hasLightBackground = "_f3-6";
export var iconWrapper = "_f3-0";
export var large = "_f3-2";
export var medium = "_f3-1";
export var small = "_f3-5";
export var xsmall = "_f3-3";